import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import {
  RELATION_HAS_PART,
  RELATION_OWNED_BY,
  RELATION_PART_OF,
} from '@backstage/catalog-model';
import { EntitySwitch, isKind } from '@backstage/plugin-catalog';
import {
  Direction,
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';

import {
  ApisCard,
  EntityAboutCard,
  EntityLayout,
  SystemRelationshipsCard,
  SystemSlackCard,
} from '@internal/plugin-medidata-catalog-react';
import {
  MaturityBreakdownTable,
  MaturitySummaryInfoCard,
} from '@internal/plugin-maturity';

import { entityWarningContent, maturitySummaryContent } from './commonContent';

import { SonarQubeRelatedEntitiesOverview } from '@backstage-community/plugin-sonarqube';

export const systemOrDomainPage = (
  <EntityLayout parentEntityRelations={[RELATION_PART_OF, RELATION_OWNED_BY]}>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={1} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={5} xs={10}>
          <Stack spacing={1}>
            <EntityAboutCard />
            <SystemSlackCard />
            <SystemRelationshipsCard />
          </Stack>
        </Grid>

        <Grid item md={4} xs={8}>
          <EntitySwitch>
            <EntitySwitch.Case if={isKind('domain')}>
              <MaturityBreakdownTable />
            </EntitySwitch.Case>
            <EntitySwitch.Case if={isKind('system')}>
              <Stack spacing={1}>
                <ApisCard />
                <MaturityBreakdownTable />
              </Stack>
            </EntitySwitch.Case>
          </EntitySwitch>
        </Grid>

        <Grid item md={3} xs={6}>
          <MaturitySummaryInfoCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/maturity" title="Maturity">
      {maturitySummaryContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/sonarqube" title="Code Quality">
      <SonarQubeRelatedEntitiesOverview
        relationType={RELATION_HAS_PART}
        entityKind="component"
      />
    </EntityLayout.Route>

    <EntityLayout.Route path="/diagram" title="Diagram">
      <EntityCatalogGraphCard
        direction={Direction.TOP_BOTTOM}
        title="Entities Diagram"
        height={700}
        unidirectional={false}
      />
    </EntityLayout.Route>
  </EntityLayout>
);
